import { gql } from '@apollo/client';

export interface AddressBlacklistType {
  id: string;
  addressId: number;
  blacklistType?: string | null;
  status: string;
  standardizedFullAddress?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
}

export interface AddressBlacklistPageResponse {
  content: AddressBlacklistType[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
}

export interface GetAddressBlacklistListResponse {
  addressBlacklistList: AddressBlacklistPageResponse;
}

export interface AddAddressBlacklistResult {
  success: boolean;
  message: string;
}

export interface AddAddressBlacklistResponse {
  addAddressBlacklist: AddAddressBlacklistResult;
}

export const GET_ADDRESS_BLACKLIST_LIST = gql`
  query GetAddressBlacklistList(
    $status: String
    $fullAddress: String
    $page: Int!
    $size: Int!
  ) {
    addressBlacklistList(
      status: $status
      fullAddress: $fullAddress
      page: $page
      size: $size
    ) {
      content {
        id
        addressId
        blacklistType
        status
        standardizedFullAddress
        createdAt
        updatedAt
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;

export const ADD_ADDRESS_BLACKLIST = gql`
  mutation AddAddressBlacklist($fullAddress: String!) {
    addAddressBlacklist(fullAddress: $fullAddress) {
      success
      message
    }
  }
`;

export const DELETE_ADDRESS_BLACKLIST = gql`
  mutation DeleteAddressBlacklist($id: Long!) {
    deleteAddressBlacklist(id: $id)
  }
`;